import { render } from "./EditUserForm.vue?vue&type=template&id=23711592&scoped=true&ts=true"
import script from "./EditUserForm.vue?vue&type=script&lang=ts"
export * from "./EditUserForm.vue?vue&type=script&lang=ts"

import "./EditUserForm.vue?vue&type=style&index=0&id=23711592&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23711592"]])

export default __exports__